import { addToCart } from 'store/checkout/checkoutActions';
import { createAddToCartEvent } from '../eventCreators';
import { createAddToCartEventPayload } from '../dataHelpers/createAddToCartEventPayload';

const emitAddToCart = ({ payload }) => {
  const addToCartEvent = createAddToCartEvent(
    createAddToCartEventPayload({
      property: payload.property,
      offer: payload.offer,
      roomType: payload.roomType,
      query: payload.query,
      initialCash: payload.initialCash ?? 0,
      pointsConversion: payload.pointsConversion,
      isRebooked: payload.isRebooked,
      ctaMessage: payload.ctaMessage,
      ctaMessageCategory: payload.ctaMessageCategory,
    }),
  );

  return addToCartEvent;
};

// eslint-disable-next-line
// @ts-ignore
export default { [addToCart]: emitAddToCart };
